import { loginUrl as defaultLoginUrl } from "@/route";
import { redirect } from "next/navigation";

export interface NotAuthenticatedProps {
  loginUrl?: string;
  callbackUrl?: string;
}
export function NotAuthenticated(props: NotAuthenticatedProps) {
  const { loginUrl = defaultLoginUrl, callbackUrl } = props;

  const url = `${loginUrl}${callbackUrl ? `?callbackUrl=${encodeURIComponent(callbackUrl)}` : ""}`;
  return redirect(url);
}
